import { render, staticRenderFns } from "./ResearchDirectionsQuestionsTile.vue?vue&type=template&id=9e3dd978&scoped=true"
import script from "./ResearchDirectionsQuestionsTile.vue?vue&type=script&lang=js"
export * from "./ResearchDirectionsQuestionsTile.vue?vue&type=script&lang=js"
import style0 from "./ResearchDirectionsQuestionsTile.vue?vue&type=style&index=0&id=9e3dd978&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e3dd978",
  null
  
)

export default component.exports